import { NgIf } from '@angular/common';
import { Component, HostListener, Input } from '@angular/core';
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';
import { CustomerDashboardCounter } from '../../../models/domain/CustomerDashboardCounter';

@Component({
    selector: 'app-average-order-value',
    imports: [],
    templateUrl: './average-order-value.component.html',
    styleUrl: './average-order-value.component.scss'
})
export class AverageOrderValueComponent {
    @Input() dashboardCounter = new CustomerDashboardCounter();
    constructor(
        public themeService: CustomizerSettingsService
    ) {}

    // Card Header Menu
    isCardHeaderOpen = false;
    toggleCardHeaderMenu() {
        this.isCardHeaderOpen = !this.isCardHeaderOpen;
    }
    @HostListener('document:click', ['$event'])
    handleClickOutside(event: Event) {
        const target = event.target as HTMLElement;
        if (!target.closest('.trezo-card-header-menu')) {
            this.isCardHeaderOpen = false;
        }
    }

}